import { Injectable } from '@angular/core';
import { ISegmento } from 'app/domains/environment/segmentos/interfaces/segmento.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SegmentoSelectorStoreService {
  private _segmentoSelectorOptions = new BehaviorSubject<ISegmento[]>([]);

  readonly segmentoSelectorOptions$: Observable<ISegmento[]> =
    this._segmentoSelectorOptions.asObservable();

  setSegmentoSelectorStore(segmentos: ISegmento[]): void {
    this._segmentoSelectorOptions.next(segmentos);
  }

  get currentValue(): ISegmento[] {
    return this._segmentoSelectorOptions.value;
  }
}
